import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { checkIfSourcesExist } from "hooks/sources";
import { useDispatch, useSelector } from "react-redux";
import MDTypography from "components/Basics/MDTypography";
import { CircularProgress } from "@mui/material";
import MDAlert from "components/Basics/MDAlert";
import { selectMaxFileSizeByType } from "redux-react/reducers/applicationReducer";
import DragAndDrop from "pages/KnowledgeBase/components/DragAndDrop";

/**
 * Import local files
 * @param {*} param0
 * @returns {JSX.Element} StepImport
 */
export default function StepImport({ format, skeleton, validStep, handleSave, handleNext }) {
	const dispatch = useDispatch();
	const { mo: MAX_FILE_SIZE_MO, bytes: MAX_FILE_SIZE_BYTES } = useSelector(state =>
		selectMaxFileSizeByType(state, format)
	);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	// Save files
	const onFilesSelection = async (localFiles, files) => {
		handleSave({
			localFiles,
			files
		});
		handleNext();
	};

	const loadFiles = async files => {
		setLoading(true);
		setError(null);

		// Validate file sizes
		const oversizedFiles = files.filter(file => file.size > MAX_FILE_SIZE_BYTES);
		if (oversizedFiles.length > 0) {
			const fileNames = oversizedFiles.map(file => file.name).join(", ");
			setError(
				t("SOURCES.FILES.fileTooLarge", {
					maxSize: `${MAX_FILE_SIZE_MO}MB`,
					files: fileNames
				})
			);
			setLoading(false);
			return;
		}

		if (lod_.isEmpty(skeleton.files)) {
			const mappedFiles = files.map(file => {
				return {
					name: file.name,
					url: file.name // For local files, the url is the file name
				};
			});

			const filesResult = await checkIfSourcesExist(dispatch, mappedFiles);

			setLoading(false);
			validStep();
			onFilesSelection(files, filesResult);
		} else {
			setLoading(false);
			validStep();
		}
	};

	useEffect(() => {
		setLoading(false);
	}, []);

	return (
		<MDBox flex="1" display="flex" flexDirection="column" style={{ height: "100%", width: "100%" }}>
			{error && (
				<MDBox sx={{ mb: 1 }}>
					<MDAlert color="error" dismissible onClose={() => setError(null)}>
						{error}
					</MDAlert>
				</MDBox>
			)}
			{loading && (
				<MDBox
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						flex: 1
					}}
				>
					<MDTypography variant="h4">{t("SOURCES.FILES.loadingFiles")}</MDTypography>
					<MDTypography variant="subtitle2">{t("SOURCES.FILES.waitWhileLoading")}</MDTypography>
					<MDBox display="flex" justifyContent="center" mt={15}>
						<CircularProgress color="info" size={50} />
					</MDBox>
				</MDBox>
			)}
			{!loading && (
				<DragAndDrop
					handleFiles={files => {
						loadFiles(Array.from(files));
					}}
				/>
			)}
		</MDBox>
	);
}
